import React, { useMemo } from "react";
import SearchAutocomplete from "../UIParts/SearchAutocomplete";
import { getHandlerCodeList } from "../../utils/namesFormater";


interface HandlerAutocompleteFieldProps {
  value: string;
  onChange: (newValue: string) => void;
  placeholder?: string;
  showIcons?: boolean;
  freeSolo?: boolean;
}

export const HandlerAutocompleteField: React.FC<HandlerAutocompleteFieldProps> = ({
  value,
  onChange,
  placeholder = "בחר יצרן...",
  showIcons = true,
  freeSolo = false,
}) => {
  const handlerList = useMemo(() => getHandlerCodeList(), []);

  const options = useMemo(() => {
    return handlerList.map((h) => h.name);
  }, [handlerList]);

  const selectedLabel = useMemo(() => {
    return handlerList.find((h) => h.code === value)?.name || value;
  }, [value, handlerList]);

  const handleSelect = (selectedLabel: string | null) => {
    if (!selectedLabel) {
      onChange("");
      return;
    }

    const match = handlerList.find((h) => h.name === selectedLabel);
    if (match) {
      onChange(match.code);
    } else if (freeSolo) {
      onChange(selectedLabel);
    } else {
      onChange("");
    }
  };

  return (
    <SearchAutocomplete
      placeholder={placeholder}
      options={options}
      value={selectedLabel}
      onChange={handleSelect}
      showIcons={showIcons}
    />
  );
};
